export default __webpack_public_path__ + "static/media/team_messy_avatar-01.40d60834.png";